
export const FETCH_OWNER = 'FETCH_OWNER'
export const FETCH_OWNER_SUCCESS = 'FETCH_OWNER_SUCCESS'
export const FETCH_OWNER_FAILURE = 'FETCH_OWNER_FAILURE'

export const CREATE_OWNER = 'CREATE_OWNER'
export const CREATE_OWNER_SUCCESS = 'CREATE_OWNER_SUCCESS'
export const CREATE_OWNER_FAILURE = 'CREATE_OWNER_FAILURE'

export const UPDATE_OWNER = 'UPDATE_OWNER'
export const UPDATE_OWNER_SUCCESS = 'UPDATE_OWNER_SUCCESS'
export const UPDATE_OWNER_FAILURE = 'UPDATE_OWNER_FAILURE'

export const DELETE_OWNER = 'DELETE_OWNER'
export const DELETE_OWNER_SUCCESS = 'DELETE_OWNER_SUCCESS'
export const DELETE_OWNER_FAILURE = 'DELETE_OWNER_FAILURE'


export const fetchOwner = (id) => ({
    type: FETCH_OWNER,
    payload: id
})

export const fetchOwnerSuccess = (owner) => ({
    type: FETCH_OWNER_SUCCESS,
    payload: owner
})

export const fetchOwnerFailed = (message) => ({
    type: FETCH_OWNER_FAILURE,
    payload: message
})


export const createOwner = (owner) => ({
    type: CREATE_OWNER,
    payload: owner
})

export const createOwnerSuccess = (message) => ({
    type: CREATE_OWNER_SUCCESS,
    payload: message
})

export const createOwnerFailed = (message) => ({
    type: CREATE_OWNER_FAILURE,
    payload: message
})


export const updateOwner = (owner) => ({
    type: UPDATE_OWNER,
    payload: owner
})

export const updateOwnerSuccess = (message) => ({
    type: UPDATE_OWNER_SUCCESS,
    payload: message
})

export const updateOwnerFailed = (message) => ({
    type: UPDATE_OWNER_FAILURE,
    payload: message
})

export const deleteOwner = (id) => ({
    type: DELETE_OWNER,
    payload: id
})

export const deleteOwnerSuccess = (message) => ({
    type: DELETE_OWNER_SUCCESS,
    payload: message
})

export const deleteOwnerFailed = (message) => ({
    type: DELETE_OWNER_FAILURE,
    payload: message
})